import { useContext } from 'react';
import { TabsContext } from './Tabs.context';
// Custom hook.
// -----------------------------------------------------------------------------
export const useTabsContext = () => {
    // Hooks.
    // -----------------------------------------------------------------------------
    const ctx = useContext(TabsContext);
    if (!ctx) {
        throw new Error('useTabs must be used within a TabsProvider');
    }
    return ctx;
};
//# sourceMappingURL=Tabs.hooks.js.map